import { render, staticRenderFns } from "./ComposePanel.vue?vue&type=template&id=59fba14b&scoped=true&"
import script from "./ComposePanel.vue?vue&type=script&lang=ts&"
export * from "./ComposePanel.vue?vue&type=script&lang=ts&"
import style0 from "./ComposePanel.vue?vue&type=style&index=0&id=59fba14b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fba14b",
  null
  
)

export default component.exports